<template>
	<div class="placeholder">
		<div class="player-content">
			<div :id="id">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
import media from "lib/modules/Media";

let idCounter = 0;

jwplayer.key= "z9rGRluR5xhfp1n2FDjbBXCuTVZRYOcXv1BrCaM9UUY=";

export default {
	name: "WebPlayer",
	props: {
		onPlayerEvent: {
			type: Function,
			default: () => false,
			required: false
		}
	},
	created() {
		this.player = null;
		this.id = "web-player-" + idCounter++;
	},
	beforeDestroy() {
		this.remove();
	},
	methods: {
		setup(options) {
			if (this.player)
				return;

			if (document.getElementById(this.id) === null) {
				console.log(`Error, element "${this.id}" does not exist in DOM!`);

				return;
			}

			// jwplayer options that should have default values
			const playerOptions = {
				advertising: typeof options.advertising === "undefined" ? { autoplayadsmuted: true } : options.advertising,
				aspectratio: typeof options.aspectratio === "undefined" ? "16:9" : options.aspectratio,
				autostart: typeof options.autostart === "undefined" ? true : options.autostart,
				controls: typeof options.controls === "undefined" ? true : options.controls,
				defaultBandwidthEstimate: typeof options.defaultBandwidthEstimate === "undefined" ? 2000000 : options.defaultBandwidthEstimate,
				mute: typeof options.mute === "undefined" ? false : options.mute,
				width: "100%"
			};

			// jwplayer options that should not be added unless they are defined
			Object.assign(playerOptions,
				typeof options.base === "undefined" ? null : { base: options.base },
				typeof options.file === "undefined" ? null : { file: options.file },
				typeof options.flashplayer === "undefined" ? null : { flashplayer: options.flashplayer },
				typeof options.playlist === "undefined" ? null : { playlist: options.playlist },
				typeof options.primary === "undefined" ? null : { primary: options.primary },
				typeof options.rtmp === "undefined" ? null : { rtmp: options.rtmp },
				typeof options.type === "undefined" ? null : { type: options.type }
			);

			this.player = jwplayer(this.id).setup(playerOptions).on("all", (eventName, eventValue) => {
				this.onPlayerEvent(eventValue);
			});
		},
		remove() {
			if (!this.player)
				return;

			this.player.remove();
			this.player = null;
		},
		addDownloadButton(title, created) {
			const name = encodeURI(media.filename(title, created));

			this.player.addButton(
				"/media/download.svg",
				"Download Video",
				() => { window.location.href = `${this.player.getPlaylistItem().file}&mode=download&name=${name}`; },
				"media-download-button"
			);
		}
	}
};
</script>

<style lang="scss" scoped>
.placeholder {
	background-color: #000000;
	padding-top: 56.25%; /* 16:9 Aspect Ratio */
	position: relative;
	width: 100%;
	.player-content {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
	}
}
</style>
